import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ActionIcon, Button, Text } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import touchTarget from '@/components/common/touchTarget.module.css';
import classes from './home.module.css';

interface HomeNoticeProps {
  readonly title: string;
  readonly hint: string;
  readonly action: { readonly to: string; readonly label: string };
  /** Закрыть напоминание крестиком. Без обработчика крестика нет. */
  readonly onClose?: () => void;
}

/** Напоминание «Главной» полосой между линиями: заголовок, пояснение, кнопка и, если можно, крестик. */
export default function HomeNotice({ title, hint, action, onClose }: HomeNoticeProps) {
  const { t } = useTranslation();
  return (
    <div className={onClose ? classes.notice : `${classes.notice} ${classes.noticeNoClose}`}>
      <div>
        <Text fw={600}>{title}</Text>
        <Text size="sm" c="gray.7">
          {hint}
        </Text>
      </div>
      <Button component={Link} to={action.to} className={classes.noticeAction}>
        {action.label}
      </Button>
      {onClose ? (
        <ActionIcon variant="subtle" color="gray" onClick={onClose} aria-label={t('common.close')} className={touchTarget.target}>
          <IconX size={18} />
        </ActionIcon>
      ) : null}
    </div>
  );
}
